import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyCart = () => {
  const suggestedCategories = [
    {
      name: 'IT Consultancy',
      icon: 'Users',
      path: '/product-catalog?category=consultancy',
      description: 'Expert guidance for your IT strategy'
    },
    {
      name: 'Infrastructure',
      icon: 'Server',
      path: '/product-catalog?category=infrastructure',
      description: 'Robust IT infrastructure solutions'
    },
    {
      name: 'Networking',
      icon: 'Network',
      path: '/product-catalog?category=networking',
      description: 'Comprehensive networking services'
    },
    {
      name: 'Software Solutions',
      icon: 'Code',
      path: '/product-catalog?category=software',
      description: 'Custom software development'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-8 lg:p-12 text-center">
      {/* Empty Cart Icon */}
      <div className="w-24 h-24 mx-auto mb-6 bg-muted rounded-full flex items-center justify-center">
        <Icon name="ShoppingCart" size={48} className="text-muted-foreground" />
      </div>
      {/* Empty State Content */}
      <h2 className="text-2xl font-semibold text-foreground mb-3">
        Your cart is empty
      </h2>
      <p className="text-muted-foreground mb-8 max-w-md mx-auto">
        Looks like you haven't added any ICT solutions to your cart yet. 
        Explore our comprehensive catalog to find the perfect solutions for your business.
      </p>
      {/* Primary Action */}
      <div className="mb-8">
        <Link to="/product-catalog">
          <Button variant="default" className="px-8">
            Browse Our Catalog
          </Button>
        </Link>
      </div>
      {/* Suggested Categories */}
      <div className="max-w-4xl mx-auto">
        <h3 className="text-lg font-semibold text-foreground mb-6">
          Popular Categories
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {suggestedCategories?.map((category) => (
            <Link
              key={category?.name}
              to={category?.path}
              className="group p-4 border border-border rounded-lg hover:border-primary hover:shadow-subtle transition-all duration-200"
            >
              <div className="flex flex-col items-center text-center">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-3 group-hover:bg-primary/20 transition-colors">
                  <Icon 
                    name={category?.icon} 
                    size={24} 
                    className="text-primary" 
                  />
                </div>
                <h4 className="font-medium text-foreground mb-1 group-hover:text-primary transition-colors">
                  {category?.name}
                </h4>
                <p className="text-sm text-muted-foreground">
                  {category?.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
      {/* Additional Actions */}
      <div className="mt-8 pt-6 border-t border-border">
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link to="/rfq-request-form">
            <Button variant="outline" className="flex items-center gap-2">
              <Icon name="FileText" size={16} />
              Request Custom Quote
            </Button>
          </Link>
          <Link to="/customer-dashboard">
            <Button variant="ghost" className="flex items-center gap-2">
              <Icon name="LayoutDashboard" size={16} />
              Go to Dashboard
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EmptyCart;